import React, { useEffect, useState } from "react";
import BreadCrumb from "src/Components/GlobalComponents/BreadCrumb";
import httpRequest from "src/helpers/httpRequest";
import { IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { toast } from "react-toastify";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import TableWrapper from "src/Components/GlobalComponents/TableWrapper";
import moment from "moment";
import {
  displayStatus,
  getLastSegment,
  capitalize,
} from "src/helpers/helperFunctions";
import { Link, useNavigate } from "react-router-dom";
import { CHECKBOX_INPUT, CURRENCY } from "src/lib/constans";
import deleteIcon from "src/assets/images/delete-icon.png";
import eyeIcon from "src/assets/images/view.png";
import ConfirmationModal from "src/Components/GlobalComponents/ConfirmationModal";
import PrintModal from "src/Components/PrintModal";
import * as XLSX from "xlsx";
import { canWrite } from "src/helpers/helperFunctions";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
interface IPharmOrder {
  _id: string;
  firstName: string;
  lastName: string;
  totalAmount: number;
  discountedPrice: number | null;
  status: string;
  serialOrderId: string;
  createdAt: string;
  email: string;
  mobile: string;
  [key: string]: any;
}
type statusEnums =
  | "pending"
  | "delivered"
  | "deleted"
  | "cancelled"
  | "completed";

interface IOrderResponse {
  documents: IPharmOrder[];
  paginated: IPaginated;
  pendingCount: number;
  cancelCount: number;
  completedCount: number;
  deliveredCount: number;
  deletedCount: number;
}

const PharmaOrders: React.FC = () => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);

  const hasWriteAccess = canWrite(userDetails, "pharmaOrder", false);
  const tabList: { label: string; key: "" | statusEnums }[] = [
    { label: "All Orders", key: "" },
    { label: "Pending", key: "pending" },
    { label: "Completed", key: "completed" },
    { label: "Cancelled", key: "cancelled" },
    { label: "Delivered", key: "delivered" },
    { label: "Deleted", key: "deleted" },
  ];
  const [activeTab, setActiveTab] = useState<"" | statusEnums>("");

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [allOrders, setAllOrders] = useState<IPharmOrder[]>([]);

  const [count, setCount] = useState<{
    totalCount: number;
    pendingCount: number;
    cancelCount: number;
    completedCount: number;
    deliveredCount: number;
    deletedCount: number;
  }>({
    totalCount: 0,
    pendingCount: 0,
    cancelCount: 0,
    completedCount: 0,
    deliveredCount: 0,
    deletedCount: 0,
  });

  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination

  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    status: "",
    search: "",
  });
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>("");
  const [printModal, setPrintModal] = useState<IPharmOrder[] | null>(null);

  const handleDelete = (id: string) => {
    if (!hasWriteAccess) {
      return;
    }
    setDeleteModal(true);
    setDeleteId(id);
  };
  const deleteModalClose = () => {
    setDeleteModal(false);
    setDeleteId("");
  };
  const confirmDelete = async () => {
    setDeleteLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      method: "delete",
      path: `/pharma-order/delete/${deleteId}`,
      params: {},
    });
    if (res) {
      toast(res?.message || "Success", { type: "success" });
      // handleTabClick("deleted");
      setDeleteModal(false);
      setDeleteId("");
    } else {
      toast(err, { type: "error" });
    }
    setDeleteLoader(false);
  };
  const onToogleSelect = (id: string) => {
    if (selectedRows.includes(id)) {
      // if is exist
      setSelectedRows((prev) => prev.filter((v) => v !== id));
    } else {
      setSelectedRows((prev) => [...prev, id]);
    }
  };
  const handleSelectAll = () => {
    setSelectedRows(allOrders.map((v) => v._id));
  };

  // Handles tab click to filter orders
  const handleTabClick = (tabName: "" | statusEnums) => {
    setSelectedRows([]);
    setActiveTab(tabName);
    setQueryParams((prev) => ({
      ...prev,
      status: tabName,
      page: 1,
      search: "",
    }));
  };

  // Updates search text in query parameters
  const handleChangeText = (txt: string) => {
    setQueryParams((prev) => ({
      ...prev,
      page: 1,
      search: txt,
    }));
  };

  // Handles page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  const downloadFile = () => {
    let data = allOrders;
    if (selectedRows.length > 0) {
      data = data.filter((mha) => selectedRows.includes(mha._id));
    }
    let seriesArrayObjectConvert = data.map((mn) => {
      return {
        "Order ID": `${String(mn.serialOrderId)}`,
        Date: moment(mn.createdAt).format("DD-MM-YYYY"),
        "Customer Name": `${mn.firstName ? capitalize(mn.firstName) : ""} ${
          mn.lastName ? capitalize(mn.lastName) : ""
        }`,
        Email: mn.email,
        "Phone Number": String(mn.mobile),
        Amount: `${CURRENCY} ${mn?.discountedPrice || mn?.totalAmount || "-"}`,
        Status: displayStatus(mn.status),
      };
    });

    console.log(
      "Object +++++++++++++++++++=====",
      data,
      "Serialized",
      seriesArrayObjectConvert
    );

    const ws = XLSX.utils.json_to_sheet(seriesArrayObjectConvert);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    XLSX.writeFile(wb, "phamacy-order.csv");
  };

  const fetchAllOrders = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IOrderResponse>({
      path: `/pharma-order/admin-all-orders?${qs.stringify(queryParams)}`,
    });
    if (res) {
      let {
        documents = [],
        paginated,
        pendingCount = 0,
        cancelCount = 0,
        completedCount = 0,
        deliveredCount = 0,
        deletedCount = 0,
      } = res;
      setAllOrders(documents);
      setPaginated(paginated);
      setCount({
        totalCount: 
        // paginated.totalItems || 0,
          pendingCount +
          cancelCount +
          completedCount +
          deliveredCount,
        pendingCount,
        cancelCount,
        completedCount,
        deliveredCount,
        deletedCount,
      });
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetchAllOrders();
  }, [queryParams]);

  const navigate = useNavigate();

  return (
    <>
      <ConfirmationModal
        show={deleteModal}
        onClose={deleteModalClose}
        title="Are you sure you want to delete?"
        leftBtnText="No"
        rightBtnText="Yes"
        onConfirm={confirmDelete}
        loader={deleteLoader}
      />
      <BreadCrumb
        current="Pharma Orders"
        previous="dashboard"
        navigateUrl="/admin"
        // AllOrders={true}
        // onPressExport={downloadFile}
        btnShow={true}
        btnText="Place Order"
        onPress={() => {
          if (!hasWriteAccess) {
            return;
          }
          navigate("/admin/pharmacy/place-order");
        }}
        btnClassName={`${
          !hasWriteAccess ? "cursor-not-allowed" : "cursor-pointer"
        }`}
        BtnId="place-order-btn"
      />
      <div className="table-container">
        <div className="flex justify-between items-center">
          <div className="products-tabs-btn">
            {tabList.map((item) => (
              <button
                key={item.key}
                className={`font-size-15px font-Poppins-Medium ${
                  activeTab === item.key && "active"
                }`}
                onClick={() => handleTabClick(item.key)}
                id={`pharma-orders-tab-${item.key}`}
              >
                {item.key === ""
                  ? `All Orders (${count.totalCount})`
                  : item.key === "pending"
                  ? `Pending (${count.pendingCount})`
                  : item.key === "cancelled"
                  ? `Canceled (${count.cancelCount})`
                  : item.key === "completed"
                  ? `Completed (${count.completedCount})`
                  : item.key === "delivered"
                  ? `Delivered (${count.deliveredCount})`
                  : item.key === "deleted"
                  ? `Deleted (${count.deletedCount})`
                  : ""}
              </button>
            ))}
          </div>
          {/* <div className='printing-and-export-btn' onClick={() => {
                        let data = allOrders;
                        if (selectedRows.length > 0) {
                            data = data.filter(mha => selectedRows.includes(mha._id));
                        }
                        setPrintModal(data)
                    }}> */}
          <div className="printing-and-export-btn">
            {/* <button disabled={!allOrders?.length} className='font-size-15px text-white font-poppins-Medium'>
                            <img src={printingIcon} alt="" />
                            <span>Print</span>
                        </button> */}
            {/* <button onClick={downloadFile} disabled={!allOrders?.length} className='font-size-15px text-white font-poppins-Medium'>
                            <img src={exportIcon} alt="" />
                            <span>Export</span>
                        </button> */}
          </div>
        </div>
        <div className="flex margin-top-issue-resolve-dash justify-end">
          <SearchFilterInput
            key={activeTab}
            inputExtraStyle={{ marginBottom: 0 }}
            onChangeText={handleChangeText}
          />
        </div>
        <hr
          className="products-tabs-hr products-tabs-hr-allOrder"
          style={{ border: "1px solid #D4D4D4" }}
        />
        <div>
          <TableWrapper
            // ref={tableRef}
            isLoading={isLoader}
            thead={[
              CHECKBOX_INPUT,
              "Order ID",
              "Date",
              "Customer Name",
              "Email",
              "Phone Number",
              "Amount",
              "Status",
              "Action",
            ]}
            page={paginated?.currentPage || 1}
            total={paginated?.totalPages || 0}
            columnWidth={"6% 10% 10% 14% 20% 14% 10% 9% 7%"}
            onChange={handlePageChange}
            selectedRows={selectedRows}
            totalLength={allOrders?.length || 1}
            clearAll={() => setSelectedRows([])}
            selectAll={handleSelectAll}
          >
            <div className="tbody-content-height tbody-content-height-allOrder">
              {allOrders?.map((item: IPharmOrder, index: number) => (
                <ul
                  key={index}
                  className={`font-size-16px tbody-light-table font-Poppins-Regular grid ${
                    !item?.adminNotified ? `font-bold` : ``
                  }`}
                  style={{
                    gridTemplateColumns: "6% 10% 10% 14% 20% 14% 10% 9% 7%",
                  }}
                >
                  <li>
                    <input
                      type="checkbox"
                      className="w-4 h-4"
                      checked={selectedRows.includes(item._id)}
                      onChange={() => onToogleSelect(item._id)}
                      id={`pharma-orders-checkbox-${index + 1}`}
                    />
                  </li>
                  <li><span className="truncate">{`${getLastSegment(item?.serialOrderId)}`}</span></li>
                  <li><span className="truncate">{moment(item?.createdAt).format("DD-MM-YYYY")}</span></li>
                  <li className="capitalize"><span className="truncate">{`${item?.name || "-"}`}</span></li>
                  <li>
                    <span className="truncate">{item?.email || "-"}</span>
                  </li>
                  <li><span className="truncate">{item?.mobile || "-"}</span></li>
                  <li><span className="truncate">{`${CURRENCY} ${(
                    item?.discountedPrice ||
                    item?.totalAmount ||
                    0
                  ).toFixed(2)}`}</span></li>
                  <li
                    style={{
                      paddingLeft: 0,
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: displayStatus(item?.status)?.bgColor,
                        color: displayStatus(item?.status)?.color,
                      }}
                      className="py-1 px-4 font-size-13px font-Poppins-SemiBold capitalize rounded"
                    >
                      {displayStatus(item?.status)?.text || ""}
                    </span>
                  </li>

                  <li className="action-last-colum">
                    <Link
                      to={
                        !hasWriteAccess
                          ? "#"
                          : `/pharmacy/order-details/${item?._id}/view?type=pharma`
                      }
                      id={`pharma-orders-view-btn-${index + 1}`}
                    >
                      <img
                        className={`${!hasWriteAccess ? "read_access" : ""}`}
                        src={eyeIcon}
                        alt=""
                      />
                    </Link>
                    {item?.status !== "deleted" ? (
                      <button
                        onClick={() => handleDelete(item?._id)}
                        id={`pharma-orders-delete-btn-${index + 1}`}
                      >
                        <img
                          className={`${!hasWriteAccess ? "read_access" : ""}`}
                          src={deleteIcon}
                          alt=""
                        />
                      </button>
                    ) : null}
                  </li>
                </ul>
              ))}
            </div>
          </TableWrapper>
        </div>
      </div>
      {printModal && (
        <PrintModal
          onClose={() => setPrintModal(null)}
          allOrders={printModal}
          headerFields={[
            "Order ID",
            "Date",
            "Customer Name",
            "Email",
            "Phone Number",
            "Amount",
            "Status",
          ]}
          columnsWidth={"9% 12% 15% 25% 17% 10% 12%"}
        />
      )}
    </>
  );
};

export default PharmaOrders;
